// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oI5o","icon":"styles_icon__-qXQn"};